<section id="edit-schedule">
  <div class="row navigator" (click)="cancel()">
    <mat-icon style="height: 22px;">keyboard_arrow_left</mat-icon>
    <span>{{ 'scheduleRotation.backToSchedule' | translate }}</span>
  </div>
  <section id='header'>
    <div class='title'>
      <div class='main'
           [title]="scheduleData?.name">{{scheduleData?.name | titlecase }}</div>
    </div>
    <div class='actions'>
      <div (click)="onSave()" class='action'>{{ 'scheduleRotation.saveChanges' | translate }}</div>
      <div (click)="cancel()" class='cancel'>{{ 'scheduleRotation.cancel' | translate }}</div>
    </div>
  </section>
  <section id="start-date">
    <form [formGroup]="dateForm">
      <div class="date row">
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label class="label">{{'otherTexts.rotationStartDate' | translate }}</mat-label>
            <input [matDatepicker]="picker"
                   [matDatepickerFilter]="dateFilter"
                   formControlName='startDate'
                   matInput
                   placeholder="{{'departmentHolidays.chooseDate' | translate}}">
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #picker (monthSelected)="nextClicked()"></mat-datepicker>
            <mat-error *ngIf="dateForm.controls.startDate.hasError('required')" [innerHTML]="'otherTexts.dateIsRequired' | translate">
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </section>
  <section id="header">
    <div class='title'>
      <div class='sub-title'>{{ 'scheduleRotation.shifts' | translate }}<span class="of">({{scheduleData?.shifts?.length || 0}})</span></div>
    </div>
    <div class='actions'>
      <div (click)="addShift()" class='cancel'>{{ 'scheduleRotation.addShift' | translate }} <span class="plus">+</span></div>
    </div>
  </section>
  <section class="row" id="shifts-list-container">
    <!-- Generated by Copilot- Start -->
    <div class="empty-shifts"
         *ngIf="!scheduleData?.shifts?.length">
      <mat-icon class="mat-icon">info_outline</mat-icon>
      <span class="label">{{ 'otherTexts.thereAreNoShiftsConfiguredForThisScheduleRotation'| translate }}</span>
    </div>
    <div *ngFor="let shiftId of (shiftIds$ | async)">
      <app-schedule-shift [config]="config" [shiftData]="getShiftById(shiftId)"></app-schedule-shift>
    </div>
    <!-- Generated by Copilot- End -->
  <section id="week-list-container">
    <!-- Generated by Copilot- Start -->
    <div class="empty-shifts"
         *ngIf="!scheduleData?.shifts?.length">
      <mat-icon class="mat-icon">info_outline</mat-icon>
      <span class="label">{{ 'otherTexts.pleaseAddAtLeastOneShiftInOrderToConfigureTheWeeks' | translate }}</span>
    </div>
    <div class="row week" *ngIf="scheduleData?.shifts?.length">
      <div class="week-container">
        <app-schedule-rotation [config]="config"
                               [weeksData]="scheduleData?.rotation"
        ></app-schedule-rotation>
      </div>
    </div>
    <!-- Generated by Copilot- End -->
  </section>
</section>
